import { render } from "./UpdateRenewalType.vue?vue&type=template&id=7b9d317e"
import script from "./UpdateRenewalType.vue?vue&type=script&lang=js"
export * from "./UpdateRenewalType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__